module.exports = __webpack_public_path__ + "img/ecf2713.jpg";